<div class="chat-container">
  <div class="messages">
    <div *ngFor="let msg of messages" [ngClass]="['bubble', msg.sender]">
      <div [innerHTML]="msg.text"></div>
    </div>
  </div>

  <form class="input-bar" (ngSubmit)="sendMessage()">
    <input
      type="text"
      [(ngModel)]="userInput"
      name="question"
      placeholder="Ask any question..."
      [disabled]="isLoading"
      required
    />

    <button type="submit" [disabled]="isLoading">
      <ng-container *ngIf="!isLoading; else loading">Send</ng-container>
      <ng-template #loading>
        <div class="spinner"></div>
      </ng-template>
    </button>
  </form>
</div>
